import React from "react";
import { Draggable } from "react-beautiful-dnd";

const EliminationCard = (props) => {

    const { card, index, isDraggingOver } = props;

    return (
        <Draggable draggableId={card.id} index={index}>
            {(provided, snapshot) => {

                const bgClass = snapshot.isDragging ? " bg-light" : " bg-transparent";

                const rightElement = index % 2 === 0 ?
                    <div className="align-self-end d-flex">
                        <div className="border-secondary border-top border-right pt-3 pr-4"></div>
                        <div className="mr-0 border-secondary border-bottom pt-3 pr-2"></div>
                    </div>
                    :
                    <div className="align-self-start d-flex">
                        <div className=" border-secondary border-bottom border-right pb-3 pr-4"></div>
                        <div className="mr-0 pb-3 pr-2"></div>
                    </div>

                const bgExtraClass = snapshot.isDragging ? "bg-transparent" : "bg-transparent";
                const extra = (index % 2 === 0) ?
                    <div></div>
                    :
                    <div className={"p-2 " + bgExtraClass}></div>

                const teamLogo = (card && card.logoUrl) ? card.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"
                return (
                    <div className={"col-12 rounded-lg p-0 "}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                    >
                        <div className={"media border-left border-2 pl-1 " + bgClass}>
                            <div className={"media flex-fill "}>
                                <div className="mt-1 mb-1 align-self-center mr-1" style={{
                                    backgroundImage: `url(${teamLogo})`,
                                    height: 25,
                                    width: 25,
                                    minWidth: 25,
                                    backgroundPosition: 'center',
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat'
                                }} />
                                {/* <img className="mt-1 mb-1 align-self-center mr-1" src={(card && card.logoUrl) || teamLogo} height="25" width="25" alt="" /> */}
                                <span className=" flex-fill text-wrap text-truncate mb-0 align-self-center">{card.title}</span>
                            </div>
                            {isDraggingOver ?
                                <></>
                                :
                                rightElement}
                        </div>
                        {extra}
                    </div>

                )
            }}
        </Draggable >
    )
}

export default EliminationCard;